import { render, staticRenderFns } from "./DashboardMenu.vue?vue&type=template&id=68d7e941&scoped=true"
import script from "./DashboardMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DashboardMenu.vue?vue&type=style&index=0&id=68d7e941&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d7e941",
  null
  
)

export default component.exports